import React from 'react'
import List from './list'
import Stack from '@mui/material/Stack'
import CreateProduct from './create'
const Products = () => {
  const [open, setOpen] = React.useState(false)
  return (
    <Stack
      direction="row"
      justifyContent="space-evenly"
      alignItems="flex-start"
      spacing={2}
    >
      <CreateProduct open={open}/>
      <List setOpen={() => setOpen(true)}/>
    </Stack>
  )
}

export default Products;